export class MediaType {
  constructor (
    /** MIME type and video codec information */
    public readonly formatName: string,
    /** MIME type */
    public readonly mimeType: string,
    /** File extension for the media type */
    public readonly fileExtension: string
  ) {}
}

/**
 * Returns an array of MediaType supported by MediaRecorder.
 *
 * By default, only returns container/codec combinations suppported
 * by Serato Visualizer.
 */
export function getMediaTypes (seratoVisualizerSupportedOnly = true): MediaType[] {
  const supportedTypes: MediaType[] = []

  if (window.MediaRecorder) {
    const mediaContainers = ['mp4', 'MP4', 'webm']
    const videoCodecs = ['avc1', 'av1', 'h264', 'h.264', 'h265', 'h.265']

    if (!seratoVisualizerSupportedOnly) {
      ['ogg', 'x-matroska'].forEach((val) => mediaContainers.push(val));
      ['vp9', 'vp9.0', 'vp8', 'vp8.0', 'opus'].forEach((val) => videoCodecs.push(val))
    }

    mediaContainers.forEach((container) => {
      const type = `video/${container}`
      videoCodecs.forEach((codec) => {
        const variations = [
          `${type};codecs=${codec}`,
          `${type};codecs:${codec}`,
          `${type};codecs=${codec.toUpperCase()}`,
          `${type};codecs:${codec.toUpperCase()}`,
          `${type}`
        ]
        let added = false
        let i = 0
        do {
          if (MediaRecorder.isTypeSupported(variations[i])) {
            supportedTypes.push(
              new MediaType(
                variations[i],
                variations[i].split(';')[0],
                variations[i].split(';')[0].split('/')[1]
              )
            )
            added = true
          }
          i++
        } while (added === false && i < variations.length)
      })
    })
  }
  return supportedTypes
}
